import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import Barcode from "react-barcode";
import MyContext from "../../../MyContext";

export default function LabelPrinting({ userID }) {
  // ✅ POS LABEL SIZE CONTROL (CHANGE VALUES ONLY HERE)
  // ✅ Zebra safe-area settings (GT820 cuts edges if you use full size)
  const POS = {
    PAGE_W: 75,   // 50 × 1.5
    PAGE_H: 37.5, // 25 × 1.5


    SAFE_MM: 2.4,          // ⬇ reduced so content grows
    BORDER_MM: 0.20,
    GAP_MM: 0.5,

    TITLE_FONT: 15.5,      // ⬆ 9.2 × 1.5
    DETAILS_FONT: 11.3,     // ⬆ 6.2 × 1.5
    DATE_FONT: 11.6,        // ⬆ 6.4 × 1.5
    BOTTOM_FONT: 7.0,      // ⬆ 6.0 × 1.5

    BARCODE_H: 25,         // ⬆ 13 × 1.5
    BARCODE_W: 1.55,       // ⬆ 0.85 × 1.5
  };


  const { baseUrl, config } = useContext(MyContext);

  const [catalogue, setCatalogue] = useState([]);
  const [formData, setFormData] = useState({
    selectedCategory: "",
    selectedItem: null,
    mfgDate: "",
    expDate: "",
    mrp: "",
    quantity: 1,
  });

  const [itemsToPrint, setItemsToPrint] = useState([]);
  const [labels, setLabels] = useState([]);
  const [layout, setLayout] = useState("layout1");

  const printRef = useRef();
  const posRef = useRef();

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  };

  useEffect(() => {
    allcatalogueAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allcatalogueAPI = async () => {
    try {
      const requestBody = { userid: userID, secret: "string" };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getCatalogItems`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setCatalogue(response.data.response);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddItem = () => {
    const { selectedItem, mfgDate, expDate, mrp, quantity } = formData;

    if (!selectedItem || !mfgDate || !expDate || !mrp || quantity < 1) {
      alert("Please fill all fields for the item");
      return;
    }

    const newItems = [
      ...itemsToPrint,
      { ...selectedItem, mfgDate, expDate, mrp, quantity },
    ];
    setItemsToPrint(newItems);

    const allLabels = [];
    newItems.forEach((item) => {
      for (let i = 0; i < item.quantity; i++) {
        allLabels.push(item);
      }
    });
    setLabels(allLabels);

    setFormData({
      selectedCategory: "",
      selectedItem: null,
      mfgDate: "",
      expDate: "",
      mrp: "",
      quantity: 1,
    });
  };

  const handleGenerate = () => {
    const allLabels = [];
    itemsToPrint.forEach((item) => {
      for (let i = 0; i < item.quantity; i++) {
        allLabels.push(item);
      }
    });
    setLabels(allLabels);
  };

  const handlePrint = () => {
    const htmlContent = `
    <html>
      <head>
        <title>Print Labels</title>
        <style>
          @page {
            size: A4;
            margin: 10mm;
          }
          html, body {
            margin: 0;
            padding: 0;
            height: 100%;
            width: 100%;
          }
          body {
            font-family: sans-serif;
            -webkit-print-color-adjust: exact;
          }
          .label-sheet {
            width: 210mm;
            height: 297mm;
            display: grid;
            grid-template-columns: repeat(3, 64mm);
            grid-template-rows: repeat(8, 34mm);
            gap: 0mm;
            padding-top: 10mm;
            padding-left: 10mm;
            padding-right: 10mm;
            margin-top: 0mm; 
            box-sizing: border-box;
          }
          .label {
            width: 64mm;
            height: 34mm;
            margin: 5mm;
            box-sizing: border-box;
            padding: 1mm;
            text-align: center;
            font-size: 12px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            border: 0.1mm solid transparent;
          }
          .barcode-wrapper {
            width: 100%;
            display: flex;
            justify-content: center;
          }
        </style>
      </head>
      <body>
        <div class="label-sheet">
          ${printRef.current?.innerHTML || ""}
        </div>
      </body>
    </html>
  `;

    const win = window.open("", "", "height=900,width=1200");
    if (!win) return;

    win.document.write(htmlContent);
    win.document.close();
    win.focus();

    setTimeout(() => {
      win.print();
      win.close();
    }, 500);
  };

  const handlePrintPOS = () => {
    const htmlContent = `
  <html>
    <head>
      <title>Print POS Labels</title>
      <style>
        @page {
          size: ${POS.PAGE_W}mm ${POS.PAGE_H}mm;  /* ✅ exact label size */
          margin: 0;
        }

        * { box-sizing: border-box; }

        html, body {
          width: ${POS.PAGE_W}mm;
          height: ${POS.PAGE_H}mm;
          margin: 0;
          padding: 0;
          overflow: hidden;
        }

        body {
          font-family: Arial, sans-serif;
          -webkit-print-color-adjust: exact;
        }
      </style>
    </head>
    <body>
      ${posRef.current?.innerHTML || ""}
    </body>
  </html>
  `;

    const win = window.open("", "", "height=600,width=420");
    if (!win) return;

    win.document.write(htmlContent);
    win.document.close();
    win.focus();

    setTimeout(() => {
      win.print();
      win.close();
    }, 500);
  };


  const layouts = {
    layout1: { columns: 5, fontSize: "10px" },
    layout2: { columns: 4, fontSize: "12px" },
    layout3: { columns: 3, fontSize: "14px" },
    layout4: { columns: 2, fontSize: "16px" },
    layout5: { columns: 1, fontSize: "18px" },
  };

  const isCategorySelected = !!formData.selectedCategory;
  const isItemSelected = !!formData.selectedItem;

  return (
    <>
      <div
        className="p-4 bg-white"
        style={{
          fontFamily: "Nunito, sans-serif",
        }}
      >
        <div className="bg-white px-4 d-flex">
          <div className="CreateCampaign p-0 m-0 mb-2">
            Label Printing System
          </div>
        </div>

        <div className="row m-0 p-0 bg-white px-4 d-flex justify-content-between">
          {/* Left: Form */}
          <div className="col-6 m-0 p-0">
            <div
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                padding: "20px",
                background: "#ffffff",
              }}
            >
              <h3
                style={{
                  marginBottom: "16px",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#2c3e50",
                  borderBottom: "2px solid #f0f0f0",
                  paddingBottom: "6px",
                }}
              >
                Create Label
              </h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "15px",
                }}
              >
                {/* Category */}
                <div>
                  <label
                    style={{
                      display: "block",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#555",
                      marginBottom: "4px",
                    }}
                  >
                    Category
                  </label>
                  <select
                    value={formData.selectedCategory}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        selectedCategory: e.target.value,
                        selectedItem: null,
                      }))
                    }
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      fontSize: "14px",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <option value="">Select Category</option>
                    {catalogue.map((cat) => (
                      <option key={cat.cat_id} value={cat.cat_id}>
                        {cat.category_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Item */}
                <div>
                  <label
                    style={{
                      display: "block",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#555",
                      marginBottom: "4px",
                    }}
                  >
                    Item
                  </label>
                  <select
                    disabled={!isCategorySelected}
                    value={formData.selectedItem?.item_id || ""}
                    onChange={(e) => {
                      const cat = catalogue.find(
                        (c) => c.cat_id === formData.selectedCategory
                      );
                      const item = cat?.menu_items?.find(
                        (i) => i.item_id === e.target.value
                      );
                      setFormData((prev) => ({ ...prev, selectedItem: item }));
                    }}
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      fontSize: "14px",
                      backgroundColor: isCategorySelected ? "#fafafa" : "#f5f5f5",
                    }}
                  >
                    <option value="">Select Item</option>
                    {isCategorySelected &&
                      catalogue
                        .find((c) => c.cat_id === formData.selectedCategory)
                        ?.menu_items?.map((item) => (
                          <option key={item.item_id} value={item.item_id}>
                            {item.item_name}
                          </option>
                        ))}
                  </select>
                </div>

                {/* Dates */}
                <div>
                  <label
                    style={{
                      display: "block",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#555",
                      marginBottom: "4px",
                    }}
                  >
                    MFG Date
                  </label>
                  <input
                    type="date"
                    disabled={!isItemSelected}
                    value={formData.mfgDate}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, mfgDate: e.target.value }))
                    }
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      fontSize: "14px",
                      backgroundColor: isItemSelected ? "#fafafa" : "#f5f5f5",
                    }}
                  />
                </div>

                <div>
                  <label
                    style={{
                      display: "block",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#555",
                      marginBottom: "4px",
                    }}
                  >
                    EXP Date
                  </label>
                  <input
                    type="date"
                    disabled={!isItemSelected}
                    value={formData.expDate}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, expDate: e.target.value }))
                    }
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      fontSize: "14px",
                      backgroundColor: isItemSelected ? "#fafafa" : "#f5f5f5",
                    }}
                  />
                </div>

                {/* Price & Quantity */}
                <div>
                  <label
                    style={{
                      display: "block",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#555",
                      marginBottom: "4px",
                    }}
                  >
                    MRP
                  </label>
                  <input
                    type="number"
                    disabled={!isItemSelected}
                    value={formData.mrp}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, mrp: e.target.value }))
                    }
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      fontSize: "14px",
                      backgroundColor: isItemSelected ? "#fafafa" : "#f5f5f5",
                    }}
                  />
                </div>

                <div>
                  <label
                    style={{
                      display: "block",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#555",
                      marginBottom: "4px",
                    }}
                  >
                    Label Quantity
                  </label>
                  <input
                    type="number"
                    min="1"
                    disabled={!isItemSelected}
                    value={formData.quantity}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        quantity: parseInt(e.target.value || "1", 10),
                      }))
                    }
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      fontSize: "14px",
                      backgroundColor: isItemSelected ? "#fafafa" : "#f5f5f5",
                    }}
                  />
                </div>
              </div>

              <button
                className="bg-green-filter"
                style={{
                  marginTop: "20px",
                  color: "#fff",
                  padding: "10px 18px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  transition: "0.2s ease",
                }}
                onMouseOver={(e) => (e.target.style.opacity = "0.9")}
                onMouseOut={(e) => (e.target.style.opacity = "1")}
                onClick={handleAddItem}
              >
                Create
              </button>
            </div>

            {/* Print Button */}
            {labels.length > 0 && (
              <>
                <button
                  className="mt-5 text-center me-4"
                  style={{
                    background: "#2196F3",
                    color: "#fff",
                    padding: "10px 22px",
                    border: "none",
                    borderRadius: "4px",
                  }}
                  onClick={handlePrintPOS}
                >
                  Print Labels (POS)
                </button>

                <button
                  className="mt-5 text-center"
                  style={{
                    background: "#2196F3",
                    color: "#fff",
                    padding: "10px 22px",
                    border: "none",
                    borderRadius: "4px",
                  }}
                  onClick={handlePrint}
                >
                  Print Labels (A4)
                </button>
              </>
            )}
          </div>

          {/* Left: POS Preview */}
          <div className="col-6 m-0 p-0">
            <h5 className="ms-4">POS Preview (50mm × 25mm)</h5>

            {/* Center + zoom only for preview */}
            <div
              className="ms-4 mt-3"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "260px",
              }}
            >
              <div style={{ transform: "scale(3)", transformOrigin: "center" }}>
                <div ref={posRef}>
                  {labels.map((label, idx) => (
                    <div
                      key={idx}
                      className="pos-label"
                      style={{
                        // ✅ CONTENT BOX (NOT full 50x25) - safe area applied
                        width: `${POS.PAGE_W - POS.SAFE_MM * 2}mm`,
                        height: `${POS.PAGE_H - POS.SAFE_MM * 2}mm`,
                        margin: `${POS.SAFE_MM}mm`,
                        marginTop: "2rem",
                        boxSizing: "border-box",
                        padding: "0.8mm",
                        fontFamily: "Arial, sans-serif",
                        display: "flex",
                        flexDirection: "column",
                        gap: `${POS.GAP_MM}mm`,
                        overflow: "hidden",
                      }}
                    >
                      {/* TITLE */}
                      <div
                        style={{
                          // border: `${POS.BORDER_MM}mm solid #000`,
                          padding: "0.6mm",
                          textAlign: "Start",
                          fontSize: `${POS.TITLE_FONT}px`,
                          fontWeight: 900,
                          lineHeight: "1.05",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {label.item_name}
                      </div>

                      {/* DETAILS + BARCODE */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1.35fr",
                          gap: "0.6mm",
                          flex: 1,                 // ✅ lets this section adapt
                          minHeight: 0,
                        }}
                      >
                        {/* Details */}
                        <div
                          style={{
                            // border: `${POS.BORDER_MM}mm solid #000`,
                            padding: "0.6mm",
                            fontSize: `${POS.DETAILS_FONT}px`,
                            fontWeight: 700,
                            lineHeight: "1.12",
                            overflow: "hidden",
                          }}
                        >
                          <div style={{ fontWeight: 900, marginBottom: "0.2mm" }}>Details</div>
                          <div>Weight: 460</div>
                          <div>MRP: ₹{label.mrp} <br /> (incl. tax)</div>
                          <div>Batch No: 311</div>
                        </div>

                        {/* Barcode */}
                        <div
                          style={{
                            // border: `${POS.BORDER_MM}mm solid #000`,
                            padding: "0.4mm",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            minWidth: 0,
                          }}
                        >
                          <Barcode
                            value={label.item_id}
                            width={POS.BARCODE_W}
                            height={POS.BARCODE_H}
                            displayValue={false}
                            margin={0}
                          />
                        </div>
                      </div>

                      {/* DATE ROW */}
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.6mm" }}>
                        <div
                          style={{
                            // border: `${POS.BORDER_MM}mm solid #000`,
                            padding: "0.45mm",
                            fontSize: `${POS.DATE_FONT}px`,
                            fontWeight: 800,
                            textAlign: "Start",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          Date of packaging -
                        </div>

                        <div
                          style={{
                            // border: `${POS.BORDER_MM}mm solid #000`,
                            padding: "0.45mm",
                            fontSize: `${POS.DATE_FONT}px`,
                            fontWeight: 900,
                            textAlign: "end",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {formatDate(label.mfgDate)}
                        </div>
                      </div>

                      {/* STATIC TEXT */}
                      <div
                        style={{
                          // border: `${POS.BORDER_MM}mm solid #000`,
                          padding: "0.5mm",
                          fontSize: `${POS.BOTTOM_FONT}px`,
                          fontWeight: 900,
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        After Open Keep Product IN Air Tight Container Only Best Before 3 months of packing Date. <br /> This Packing of Customer Demand.
                      </div>
                    </div>

                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
